function dropdown(){
    const SELECTOR = ".js_dropdown";
    const dropdowns = window.document.querySelectorAll(SELECTOR);

    if (dropdowns.length < 1) return;

    dropdowns.forEach(dropdown => {
        dropdown.addEventListener('click',toggleSelect);
    });
    function toggleSelect(){
        const optionContainer = this.querySelector('.accordion-body');
        
        if (optionContainer.style.maxHeight) closeSelect(optionContainer);
        else openSelect(optionContainer);
    }

    function captureOutsideClick(e){
        const activeDropdown = window.document.querySelectorAll(SELECTOR + '.active');
        if (activeDropdown.length < 1) return;
        activeDropdown.forEach(dropdown => {
            if ( e.target === dropdown || dropdown.contains(e.target)) return;
            const optionContainerActive = dropdown.querySelector('.accordion-body');
            closeSelect(optionContainerActive);
        });
    }
    function closeSelect (panel){
        const dropdown = panel.closest(SELECTOR);
        dropdown.classList.remove('active');
        panel.style.maxHeight = null;
        document.body.removeEventListener("click",captureOutsideClick);
    }
    function openSelect(panel){
        const dropdown = panel.closest(SELECTOR);
        dropdown.classList.add('active');
        panel.style.maxHeight = panel.scrollHeight + "px";
        document.body.addEventListener('click',captureOutsideClick);
    }
}
window.addEventListener('load',dropdown);